import { render, staticRenderFns } from "./IconSvgWmv.vue?vue&type=template&id=5babbaaa&scoped=true&"
import script from "./IconSvgWmv.vue?vue&type=script&lang=js&"
export * from "./IconSvgWmv.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5babbaaa",
  null
  
)

export default component.exports